import { createSlice } from '@reduxjs/toolkit';
import { getAnswerByIdAPI, searchAnswerAPI } from '../../../service/quiz/quiz.answer.service';

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  answers: [],
  answer: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: 'asc',
        property: 'createdAt',
      },
    ],
  },
};

const slice = createSlice({
  name: 'answer',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setAnswers(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.answers = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setAnswer(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.answer = response.data;
    },
    setAnswerSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
// Actions
export const { setAnswerSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getAnswers() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { answer } = getState();

    const resp = await searchAnswerAPI({ ...answer.search, value: `%${answer.search.value}%` });

    if (resp.code === '200') dispatch(slice.actions.setAnswers(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}

export function getAnswer(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getAnswerByIdAPI(id);
    if (resp.code === '200') dispatch(slice.actions.setAnswer(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}
